Cobalt.MarkupEditor = function (editor) {
    this.editor = editor; // The editor DIV
    this.richEditor = this.editor.find(".j-wysiwyg-editor");
    this.textEditor = this.editor.find(".j-markup-editor");
    this.tabNav = this.editor.find(".j-tab-nav"); // The tabbed navigation UL
    this.tabContent = this.editor.find(".j-tab-content"); // The tabbed navigation UL
    this.isNewContent = this.editor.attr("data-is-new-content") == "true"; // Whether or not this is new or existing content
    this.markupTypeField = this.editor.find('.j-markup-type'); // The hidden INPUT box which stores the current markup mode
    this.markupSelectField = this.editor.find('.j-markup-type-selector'); // The SELECT which allows the user to change the markup mode
    this.initialize();
};

Cobalt.MarkupEditor.prototype = {

    editor: null,
    richEditor: null,
    textEditor: null,
    tabNav: null,
    tabContent: null,
    isNewContent: false,
    markupTypeField: null,
    markupSelectField: null,
    initialize: function () {
        var that = this;
        
        this.setDefaultMarkupType();

        // Update the markup/editor tabs to show the correct tab, for the current markup mode.
        if (this.getMarkupMode() == "1" || (this.getMarkupMode() == "3" && !document.location.pathname.startsWith("/cp/cms/")))  // 1 is html, 3 is bbcode
        {
            this.setMode("editor");
        }
        else // Everything else uses the markup editor
        {
            this.setMode("markup");
        }

        // Bind to the tab select event
        this.tabNav.bind('tabsselect', function (event, selectedTab) { that.handleTabClick(event, selectedTab); });

        // Set the previous-value
        this.markupSelectField.data("previous-value", this.markupSelectField.val());

        // When focused, set the previous value data
        this.markupSelectField.focus(function (e) {
            $(this).data("previous-value", $(this).val());
        });

        // When changed, handle the markup mode differences
        this.markupSelectField.change(function (e, isInitialLoad) { that.handleMarkupTypeChange(e, isInitialLoad); });
        this.markupSelectField.trigger("change", true);
        
        this.editor.data("markup-editor", this); // Make a reference from the element back to this instance

    },
    getMarkupMode: function () {
        return this.markupTypeField.val().toString();
    },
    getMarkupModeName: function () {
        return this.markupTypeField.val().toString() == "1" ? "editor" : "markup";
    },
    getMarkupType: function () {
        return (this.markupSelectField.val() || "").toString();
    },
    getPreviousMarkupType: function () {
        return (this.markupSelectField.data("previous-value") || "").toString();
    },
    setMode: function (mode) {

        // Tab Navigation
        this.tabNav.find("li[data-markup-mode]").removeClass("selected");
        this.tabNav.find("li[data-markup-mode=" + mode + "]").addClass("selected");
        // Tab Content
        this.tabContent.find("div[data-markup-mode]").hide();
        this.tabContent.find("div[data-markup-mode=" + mode + "]").show();

    },
    setDefaultMarkupType: function () {
        if (this.isNewContent && Cobalt.User.Preferences.MarkupType != null) // If this is new content, set the markup type to the user's preference
        {
            // Ensures that this is still a valid markup option!
            if (this.markupSelectField.find('option[value=' + Cobalt.User.Preferences.MarkupType + ']').length > 0) {
                this.markupTypeField.val(Cobalt.User.Preferences.MarkupType);
                this.markupSelectField.val(Cobalt.User.Preferences.MarkupType);
            }
        }
    },
    handleMarkupTypeChange: function (event, isInitialLoad) {

        var previousVal = this.getPreviousMarkupType();
        var val = this.getMarkupType();

        var content = this.textEditor.val();

        if (content != null && content != "" && previousVal == "6" && val == "2") {

            if (confirm("Are you sure you wish to switch to plain text editing? Any rich HTML you've created will be converted to plain text.")) {
                var plainText = $("<div>").html(this.textEditor.val())[0].textContent;
                this.textEditor.val(plainText);
            }
            else {
                $(this).val(6);
                return;
            }
        }

        this.textEditor.markItUpRemove();

        var $option = this.markupSelectField.find("option[value=" + val + "]");
        this.markupSelectField.parent().attr("data-markup-name", $option.attr("data-name"));

        // only change the hidden input field when the selector is enabled
        // and the change event isn't the initial one fired
        if (this.markupSelectField.is(':enabled') && !isInitialLoad) {
            this.markupTypeField.val(val);
        }

        var name = $option.attr("data-name");
        if (name) {
            var markItUpSet = Cobalt.Markup.markItUpSets[name.toLowerCase()];
            if (markItUpSet) {
                markItUpSet = $.extend(Cobalt.Markup.markItUpSets.base, markItUpSet);
                this.textEditor.markItUp(markItUpSet);
            }
        }
    },
    handleTabClick: function (event, selectedTab) {

        selectedTab = $(selectedTab);
        this.richEditor.tinymce = Cobalt.TinyMCE.editors[this.richEditor.attr("id")];
        if (this.richEditor.tinymce == undefined) {
            $.log("TinyMCE is undefined!");
            return;
        }

        var markupMode = selectedTab.attr("data-markup-mode");

        if (markupMode == "editor")  // WYSIWYG Tab
        {
            var content = this.textEditor.val();

            // Set the content
            if (content != null) {
                if (this.richEditor.tinymce !== undefined) {
                    this.richEditor.tinymce.setContent(content);
                } else {
                    this.richEditor.val(content);
                }
            }

            // Set the markup type
            this.markupTypeField.val(1);
        }
        else if (selectedTab.is('.tab-markup')) // Markup Tab
        {
            // If the raw html markup type is available, use it, otherwise get the text representation
            var content = this.richEditor.tinymce !== undefined ? this.richEditor.tinymce.getContent() : this.richEditor.val();
            var rawHtmlMarkupType = 6;
            var plaintextMarkupType = 2;

            if (content != null) {

                if (this.markupSelectField.find('option[value=' + rawHtmlMarkupType + ']').length > 0)  // Raw Html
                {
                    this.markupSelectField.val(rawHtmlMarkupType);
                }

                this.textEditor.val(content);
            }

            this.markupSelectField.change();
        }
    },
    getCurrentValue: function () {

        var markupMode = this.getMarkupModeName();

        if (markupMode == "editor")  // WYSIWYG Tab
        {
            return this.richEditor.val();
        }
        else {
            return this.textEditor.val();
        }
    }

};


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.MarkupEditor.js